import { CSSObject } from "@emotion/react";
import {
  constants,
  cssVariableStyles,
  typographyStyles,
} from "@newsela/angelou";

const {
  colors: { ui },
} = constants;
const { fontFamily, textLObj } = typographyStyles;
const { generateIconColorCss } = cssVariableStyles;

const whiteIcon = generateIconColorCss({ primaryColor: ui.white[500] });
const sharedBorderRadius = "16px";

export const cardCss = (imageSrc?: string | null) => ({
  border: 0,
  height: "304px",
  background: imageSrc ? `no-repeat url(${imageSrc}) center/cover` : null,
  backgroundColor: ui.purple[100],
  borderRadius: sharedBorderRadius,
  display: "flex",
  flexDirection: "column",
  justifyContent: "end",
  alignItems: "center",
  "&&>a::after": {
    borderRadius: sharedBorderRadius,
  },
});

export const noImageCss = {
  width: "auto",
};

export const footerCss: CSSObject[] = [
  textLObj,
  {
    backgroundColor: ui.purple[700],
    borderBottomLeftRadius: sharedBorderRadius,
    borderBottomRightRadius: sharedBorderRadius,
    color: ui.white[100],
    display: "flex",
    fontWeight: "bold",
    gap: 8,
    padding: "16px",
    width: "100%",
    ...fontFamily.noto,
  },
];

export const iconCss = {
  ...whiteIcon,
};
